import { connect } from 'react-redux';
import MessageTab from '../components/message-tab';
import { fetchHistory, getHistoryDataNext } from './message-center-actions';
import { openPlanningAndView } from '../../gantt/containers/gantt-actions';

const mapStateToProps = state => ({
  messages: state.messageCenter.history,
  isLoading: state.messageCenter.isLoadingHistory,
  error: state.messageCenter.error,
  isNextLoading: state.messageCenter.isNextHistoryDataLoading,
  hasNextData: state.messageCenter.hasNextHistoryData,
  totalCount: state.messageCenter.totalCount,
});

const mapDispatchToProps = {
  fetchData: fetchHistory,
  loadMore: getHistoryDataNext,
  openPlanningAndView,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MessageTab);
